import { STORE_APP_BANNER_ENTRY, IS_DJI_STORE, IS_DJI_MIMO, IS_DJI_MIMO_IOS, MIMO_APP_LIST_ENTRY } from '../constants/index';

export const handleBannerAdResourceUrl = (url: string) => {
  return url.indexOf("https://") < 0 ? process.env.RESOURCE_URL+ 'data/attachment/' + url : url
}

/**
 * 判断是否为商城APP内&URL链接标识符匹配正确
 * @param entry URL链接标识符
 * @return true/false
 */
export const isStoreAppBannerEntry = (entry: string | string[] | undefined, ua?: string): boolean => {
  let isDjiStore = IS_DJI_STORE;
  if (ua) {
    isDjiStore = /DJI-App-(Ios|Android)/i.test(ua);
  }
  if (entry === undefined) {
    return false;
  }
  if (typeof entry === 'string') {
    // app嵌入webview banner配置的链接内参数后面有可能携带'/'
    return (entry === STORE_APP_BANNER_ENTRY || entry === `${STORE_APP_BANNER_ENTRY}/`) && isDjiStore;
  }
  if (Array.isArray(entry)) {
    return (entry.includes(STORE_APP_BANNER_ENTRY) || entry.includes(`${STORE_APP_BANNER_ENTRY}/`)) && isDjiStore;
  }
  return false;
};

/**
 * 判断是否为mimo APP内首页社区资源位&URL链接标识符匹配正确
 * @return true/false
 */
export const isMimoHomeListEntry = (): boolean => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const entry = (url.searchParams.get('entry')) || '' as string | string[] | undefined;
  let isDjiMimo = IS_DJI_MIMO;
  if (entry === undefined) {
    return false;
  }
  if (typeof entry === 'string') {
    // app嵌入webview banner配置的链接内参数后面有可能携带'/'
    return (entry === MIMO_APP_LIST_ENTRY || entry === `${MIMO_APP_LIST_ENTRY}/`) && isDjiMimo;
  }
  if (Array.isArray(entry)) {
    return (entry.includes(MIMO_APP_LIST_ENTRY) || entry.includes(`${MIMO_APP_LIST_ENTRY}/`)) && isDjiMimo;
  }
  return false;
};

/**
 * 判断是否为mimo ios APP内首页社区资源位&URL链接标识符匹配正确
 * @return true/false
 */
export const isMimoIosHomeListEntry = (): boolean => {
  if (isMimoHomeListEntry()) {
    return IS_DJI_MIMO_IOS;
  }
  return false;
};

/**
 * 判断是否为有效域名
 * 该函数用于检验字符串是否为合法的域名格式
 * 安全性验证包括：
 * 1. 拒绝危险协议（data:, javascript:, vbscript: 等）
 * 2. 只允许安全协议（http:, https:, // 相对协议）
 * 3. 校验域名是否在白名单内
 * 
 * @param domain 待验证的域名字符串或URL
 * @return 返回true表示是合法域名，false表示非法域名
 */
export const isValidDomain = (domain: string): boolean => {
  if (!domain || typeof domain !== 'string') {
    return false;
  }

  // 1. 拒绝危险协议
  const dangerousProtocols = ['javascript:', 'data:', 'vbscript:', 'file:', 'about:'];
  const lowerDomain = domain.toLowerCase().trim();
  if (dangerousProtocols.some(protocol => lowerDomain.startsWith(protocol))) {
    return false;
  }

  // 2. 提取 hostname
  let hostname = '';
  try {
    // 相对协议 URL：//domain.com
    if (domain.startsWith('//')) {
      hostname = domain.substring(2).split('/')[0].split('?')[0].split('#')[0];
    } 
    // 完整 URL：http(s)://domain.com
    else if (domain.includes('://')) {
      // 只允许 http 和 https 协议
      if (!lowerDomain.startsWith('http://') && !lowerDomain.startsWith('https://')) {
        return false;
      }
      const url = new URL(domain);
      hostname = url.hostname;
    }
    // 纯域名或相对路径
    else {
      // 尝试提取域名部分
      hostname = domain.split('/')[0].split('?')[0].split('#')[0];
    }
  } catch (e) {
    // URL 解析失败
  }

  // 3. hostname 不能为空
  if (!hostname) {
    return false;
  }

  // 4. 允许的二级域名白名单
  const allowedDomains = [
    '.youku.com',
    '.skypixel.com',
    '.djivideos.com',
    '.qq.com',
    '.720yun.com',
    '.bilibili.com',
    '.b23.tv',
    '.aasky.net'
  ];
  
  // 5. 严格匹配：要么完全等于白名单域名，要么是其子域名
  return allowedDomains.some(allowedDomain => {
    const baseDomain = allowedDomain.substring(1); // 去掉前导点
    return hostname === baseDomain || hostname.endsWith(allowedDomain);
  });
};
